import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      // A API não conseguiu conferir a sessão (banco ou Redis fora, API reiniciando). Ela
      // preserva os cookies de propósito, mas deixar a tela de pé mostraria só uma fila de
      // erros sem saída: volta para o login, onde entrar de novo resolve.
      const sessaoIndisponivel =
        error.status === 503 &&
        String(error.error?.message ?? '').includes('Authentication temporarily unavailable');
      // `/user/me` fica de fora: é a checagem da subida (inclusive no próprio login). Sair ali
      // recarregava o login em loop enquanto a API estivesse fora; sem sessão, o guard já leva
      // ao login com a tela de origem.
      if (sessaoIndisponivel && !req.url.includes('/logout') && !req.url.includes('/user/me')) {
        authService.logout('indisponivel').subscribe();
        return throwError(() => error);
      }

      switch (error.status) {
        case 401:
          if (
            !req.url.includes('/sign-in') &&
            !req.url.includes('/exchange-code') &&
            !req.url.includes('/logout') &&
            !req.url.includes('/user/me')
          ) {
            authService.logout('expirada').subscribe();
          }
          break;
        // 403 NÃO derruba a sessão. 401 é "não sei quem você é" — aí sair faz sentido.
        // 403 é "sei quem você é, e isso você não pode": a sessão continua válida, e
        // deslogar transforma um endpoint restrito em queda de sessão para o usuário.
        // Foi o que acontecia com o gestor predial ao abrir o formulário de tarefa, que
        // consulta uma rota exclusiva do corretor. Quem chamou trata o erro.
      }

      return throwError(() => error);
    }),
  );
};
